import {
  getIsYesNoSplitDataToggleEnabled,
  getStartNodeTriggerNodeClass,
} from 'modules/workflows/ducks/selectors';
import { useIsMatchTriggeringEventSelected } from '../YesNoSplitEditor.hooks';
import { UNFILTERABLE_TRIGGERS } from 'modules/workflows/utils/nodeUtils/fieldsMatchUtils';
import { useSelector } from 'react-redux';
import { INDETERMINABLE_ORIGIN_TRIGGERS } from 'modules/workflows/utils/nodeUtils/fieldsMatchUtils';
import { useMemo } from 'react';

const mergedTriggers = [...INDETERMINABLE_ORIGIN_TRIGGERS, ...UNFILTERABLE_TRIGGERS];

export const useShouldFilterFieldsAndProperties = () => {
  const startNodeNodeClass = useSelector(getStartNodeTriggerNodeClass);
  const isYesNoSplitDataToggleEnabled = useSelector(getIsYesNoSplitDataToggleEnabled);
  const isMatchTriggeringEventSelected = useIsMatchTriggeringEventSelected();
  const shouldFilterFieldsAndProperties = useMemo(() => {
    return (
      isYesNoSplitDataToggleEnabled &&
      isMatchTriggeringEventSelected &&
      !mergedTriggers.includes(startNodeNodeClass)
    );
  }, [startNodeNodeClass, isYesNoSplitDataToggleEnabled, isMatchTriggeringEventSelected]);

  return shouldFilterFieldsAndProperties;
};
